import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AICourseFinderComponent } from '../ai-course-finder/ai-course-finder.component';
import { TemplateAiEducationComponent } from '../template-ai-education/template-ai-education.component';
import { CommonModule } from '@angular/common';
import { GenericTemplateAiComponent } from '../generic-template-ai/generic-template-ai.component';

@Component({
  selector: 'app-template-ai-analysis',
  standalone: true,
  imports: [
    AICourseFinderComponent,
    TemplateAiEducationComponent,
    CommonModule,
    GenericTemplateAiComponent,
  ],
  templateUrl: './template-ai-analysis.component.html',
  styleUrl: './template-ai-analysis.component.scss'
})
export class TemplateAiAnalysisComponent implements OnInit {

  type: string = '';
  projectId: string | null = null;
  projectdataId: string | null = null;
  showViews: any = {
    'university': false,
    'student': false,
    'generic': false,
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {
    const urlParts = this.router.url.split('/');
    this.type = urlParts[urlParts.length - 1];
  }

  ngOnInit(): void {
    // Check for project ID parameter
    this.route.params.subscribe(params => {
      this.projectId = params['projectId'] || null;
      this.type = 'generic';
    });
    
    // Check for projectdataId query parameter
    this.route.queryParams.subscribe(queryParams => {
      this.projectdataId = queryParams['projectdataId'] || null;
    });
    
    this.loadView();
  }

  loadView() {
    // Reset all views
    this.showViews = {
      'university': false,
      'student': false,
      'generic': false,
    };

    // Map the new route structure to the correct view
    switch (this.type) {
      case 'university':
        this.showViews['university'] = true;
        break;
      case 'student':
        this.showViews['student'] = true;
        break;
      case 'education-university':
        // Handle old structure for backward compatibility
        this.showViews['university'] = true;
        break;
      case 'education-student':
        // Handle old structure for backward compatibility
        this.showViews['student'] = true;
        break;
      case 'generic':
        this.showViews['generic'] = true;
        break;
      default:
        // Default to university view if no valid type
        if (this.type.includes('generic')) {
          this.showViews['generic'] = true;
        } else {
          this.showViews['university'] = true;
        }
        break;
    }
  }
}
